import React, { useRef } from 'react';
import emailjs from 'emailjs-com';
import {
  FaAt,
  FaMobile,
  FaMapMarkerAlt,
  FaPaperPlane,
  FaArrowAltCircleUp,
} from 'react-icons/fa';
import './ContactMe.css';

const ContactMe = () => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'gmail',
        'template_bry71um',
        form.current,
        'user_u9kg5yWEu2ZWV1xg2ogtX'
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
    alert('Message Send Successfully!');
  };
  return (
    <>
      <section
        style={{ overflow: 'hidden' }}
        className='container'
        id='contact_me'
      >
        <div className='contact-body'>
          <div
            style={{ margin: '84px' }}
            className='info col-6'
            class='content aos-init aos-animate'
            data-aos='fade-right'
            data-aos-duration='3000'
            data-aos-delay='50'
          >
            <h2 className='title mb-5 text-white'>
              Contact <span>With</span> Me
            </h2>
            <div className='contact-info'>
              <div className='d-flex m-2'>
                {' '}
                <FaAt className='contact-icon' size='2rem' />
                <p> masudtalukdar.cn@gmail.com</p>
              </div>
              <div className='d-flex m-2'>
                {' '}
                <FaMobile className='contact-icon' size='2rem' />
                <p> +8615589528030</p>
              </div>
              <div className='d-flex m-2'>
                {' '}
                <FaMapMarkerAlt className='contact-icon' size='2rem' />
                <p> Shandong,China</p>
              </div>
            </div>
          </div>

          <div
            className='col-6'
            data-aos='fade-left'
            data-aos-duration='3000'
            class='aos-init aos-animate'
            data-aos-delay='10'
          >
            <form ref={form} onSubmit={sendEmail}>
              <h3 className='text-white'>
                Leave <span>A Message</span>
              </h3>
              <input
                type='text'
                placeholder='Name'
                className='box'
                name='fullName'
                required
              />

              <input
                type='text'
                placeholder='Email'
                className='box'
                name='email'
                required
              />

              <input
                type='text'
                placeholder='Phone'
                className='box'
                name='phone'
                required
              />

              <input
                type='text'
                placeholder='Subject'
                className='box'
                name='subject'
                required
              />
              <textarea
                type='text'
                name='message'
                id=''
                className='box message'
                placeholder='message'
                required
              ></textarea>
              <br />
              <button
                type='submit'
                value='send'
                className='btn text-white send-text '
              >
                {/* send */}
                <FaPaperPlane className='contact-icon-send' size='2rem' />
              </button>
            </form>
          </div>
        </div>
        <a id='go-top' href='#head'>
          <FaArrowAltCircleUp className='contact-icon-send' size='3rem' />
        </a>
      </section>
    </>
  );
};

export default ContactMe;
